import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { TAB_MEDIA_PAGE_LINK } from './constants'

const initialState = {
    classes: [],
    paramSearchLessons: { bookId: 0, bookIndexId: 0, subjectId: 0, bookGroupId: 0, classId: 1, bookLessonPlanTypeId: 0, pageLinkGroupId: 0, keyword: '', filterType: TAB_MEDIA_PAGE_LINK, className: '', pageIndex: 1, pageSize: 12, sort: '', direction: '' },
    bookIdActiveSuccess: 0,
    paramFilterBook: {subjectId: 0, bookGroupId: 0, classId: 0, pagelinkTypeId: 0, pageIndex: 1, pageSize: 12, pageLinkGroupId: 0, scrollData: false},
    paramFilterBookLesson: {subjectId: 0, bookGroupId: 0, classId: 0, lessonGroupId: 0, pageIndex: 1, pageSize: 12, bookLessonPlanTypeId: 0, scrollData: false},
    paramActiveLearning: {subjectId: 0, bookGroupId: 0, classId: 0, lessonGroupId: 0, pageIndex: 1, pageSize: 12, bookLessonPlanTypeId: 0, scrollData: false},
    resultBookPageLinkFilter: [],
    resultBookLessonFilter: [],
    resultBookActiveLearning: []
}
const { classes, paramSearchLessons, bookIdActiveSuccess, paramFilterBook, paramFilterBookLesson, paramActiveLearning, resultBookPageLinkFilter, resultBookLessonFilter, resultBookActiveLearning } = initialState
const state = {classes, paramSearchLessons, bookIdActiveSuccess, paramFilterBook, paramFilterBookLesson, paramActiveLearning, resultBookPageLinkFilter, resultBookLessonFilter, resultBookActiveLearning}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
    initialState
}